import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { Observable } from "rxjs";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { ILevelPrice } from "src/app/interfaces/level-price";

@Injectable({
  providedIn: "root"
})
export class LevelPriceService {
  constructor(private core: CoreService) { }

  getList(leveleId: number, courseTypeId: number, page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.levelPrice.list + leveleId + "&CourseTypeId=" + courseTypeId,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize, null, true)
    );
  }

  add(data: ILevelPrice): Observable<any> {
    return this.core.post(
      ServiceRoute.levelPrice.add,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data): Observable<any> {
    return this.core.delete(
      ServiceRoute.levelPrice.delete,
      new CommonHttpOption().headers,
      data
    );
  }
}
